// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3XHek","inputDescription":"styles_inputDescription__36bEp"};